export default function toMap<T extends object, Key extends keyof T>(arr: T[], key: Key): Map<T[Key], T> {
  const map = new Map<T[Key], T>();
  arr.forEach((value) => map.set(value[key], value));
  return map;
}
